import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ContactDialogComponent } from 'src/app/components/contact-dialog/contact-dialog.component';
import { SimpleTextDialogComponent } from 'src/app/components/simple-text-dialog/simple-text-dialog.component';
import { ageRequirement } from 'src/app/constants/ageRequirement';
import { Subscription } from 'src/app/models/subscription.model';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'subscription-card',
  standalone: false,
  templateUrl: './subscription-card.component.html',
  styleUrl: './subscription-card.component.scss'
})
export class SubscriptionCardComponent implements OnInit {
  @Input() subscription: Subscription;
  @Input() activeSubscriptionId: string;
  @Input() activeSubscriptionExpiryDate: Date;
  @Input() isUnderAge: boolean;

  subscriptionPeriodImage: string;
  extraOwned: boolean = false;
  priceText: string;

  ageRequirement: number = ageRequirement;

  constructor(
    private readonly translateService: TranslateService,
    private readonly dialog: MatDialog,
    private readonly authService: AuthService
  ){}

  ngOnInit(): void {
    if(this.subscription.isExtra) {
      this.extraOwned = this.authService.extrasSubRoles.includes(this.subscription.name);
    }

    switch (this.subscription.period) {
      case 'monthly':
        this.subscriptionPeriodImage = "assets/images/label_month.png";
        break;

      case 'yearly':
        this.subscriptionPeriodImage = "assets/images/label_year.png";
        break;
    
      default:
        break;
    }

    if(!this.subscription.features || this.subscription.features.length < 1) {
      this.priceText = "€_ _ _";
      return;
    }

    if(!this.subscription.price) {
      this.translateService.get('subscription.free').subscribe(value => {
        this.priceText = `${value}`;
      });
      return;
    }

    this.priceText = `€ ${this.subscription.price}`;
  }

  subscribe(): void {
    if(!this.subscription.buyUrl) return;
    if(!this.subscription.features || this.subscription.features.length < 1) return;
    if(this.subscription.hasAgeRequirement && this.isUnderAge) return;
    if(this.subscription.name.toLowerCase() === "scout" && !this.isUnderAge) return;

    if(this.activeSubscriptionId) {
      const formattedDate = this.activeSubscriptionExpiryDate
        ? new Date(this.activeSubscriptionExpiryDate).toLocaleDateString('nl-NL')
        : 'onbekende datum';

      this.translateService
        .get('subscription.active_subscription_prevents_purchase', { date: formattedDate })
        .subscribe((translatedText: string) => {
          this.dialog.open<SimpleTextDialogComponent>(
            SimpleTextDialogComponent,
            {
              data: {
                title: 'subscription.dialog_title',
                text: translatedText,
                showButton: false,
              },
              autoFocus: false,
            }
          );
        });

      return;
    }
    
    window.open(this.subscription.buyUrl);
  }

  contact(): void {
    if(!this.subscription.features || this.subscription.features.length < 1) return;
    if(this.subscription.hasAgeRequirement && this.isUnderAge) return;

    var subName = '';
    this.translateService.get('subscription.name.' + this.subscription.name.toLowerCase()).subscribe(value => 
      subName = value
    );

    const params = { subName: subName.toLowerCase() };
    this.translateService
      .get(
        [
          'subscription.extra_role_contact_title',
          'subscription.extra_role_contact_explanation_placeholder'
        ],
        params
      )
      .subscribe(translations => {
        this.openContactDialog(
          translations['subscription.extra_role_contact_title'],
          translations['subscription.extra_role_contact_explanation_placeholder']
        );
      });
  }

  openContactDialog(subject: string, placeholder: string): void {
    this.dialog.open<ContactDialogComponent>(ContactDialogComponent, {
      data: { 
        name: subject, 
        placeholder: placeholder
      },
      autoFocus: false, // To prevent select state of close button in header
      });
    }
}
